import { faRobot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Skeleton, Switch, Typography } from 'antd';

import { PREFIX } from '@app/constants';
import {
  AI_SERVICES_DICTIONARY,
  AI_SERVICE_TOKEN_NOTE,
  CALL_GRADING_SERVICE_KEY,
} from '@app/pages/PaidAiFeatures/constants/aiServicesDictionary';
import { usePaidAiFeatures } from '@app/pages/PaidAiFeatures/hooks';
import { generateKey } from '@app/utils';

import type { FC } from 'react';

import '@app/pages/PaidAiFeatures/styles/PaidAiFeatures.scss';

const { Text } = Typography;

export const PaidAiFeatures: FC = () => {
  const {
    services,
    isDataLoading,
    togglingKey,
    isCallGradingLocked,
    handleToggle,
  } = usePaidAiFeatures();

  return (
    <div className={`${PREFIX}paid-ai-features`}>
      <Text type="secondary" className="bc-paid-ai-features__subtitle">
        Включайте только то, что нужно команде — списание идёт за фактическое
        использование
      </Text>

      {isDataLoading ? (
        <Skeleton active />
      ) : (
        <div className="bc-paid-ai-features__list">
          {services.map(({ Key, IsOn }) => {
            if (!Key) return null;

            const dictionaryItem = AI_SERVICES_DICTIONARY[Key];
            const title = dictionaryItem?.title ?? Key;
            const description = dictionaryItem?.description;
            const icon = dictionaryItem?.icon ?? faRobot;
            const isLocked =
              Key === CALL_GRADING_SERVICE_KEY && isCallGradingLocked;

            return (
              <div
                className={`bc-paid-ai-features__card${
                  isLocked ? ' bc-paid-ai-features__card--locked' : ''
                }`}
                key={generateKey('PaidAiFeatures', 'card', Key)}
                data-testid={`${Key}-card`}
              >
                <div className="bc-paid-ai-features__icon">
                  <FontAwesomeIcon icon={icon} size="lg" />
                </div>
                <div className="bc-paid-ai-features__content">
                  <Text strong className="bc-paid-ai-features__title">
                    {title}
                  </Text>
                  {description && (
                    <Text
                      type="secondary"
                      className="bc-paid-ai-features__description"
                    >
                      {description}
                    </Text>
                  )}
                  <Text
                    type="warning"
                    className="bc-paid-ai-features__note"
                    data-testid={`${Key}-note`}
                  >
                    {AI_SERVICE_TOKEN_NOTE}
                  </Text>
                </div>
                <Switch
                  checked={IsOn}
                  loading={togglingKey === Key}
                  disabled={isLocked}
                  onChange={(checked) => handleToggle(Key, checked)}
                  data-testid={`${Key}-switch`}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
